import { ref } from "vue";

type AnyFunction = (...args: unknown[]) => unknown;
export function useLoading(fn: AnyFunction) {
    const loading = ref(false);

    const callback = async (...args: any[]) => {
        loading.value = true;
        try {
            return await fn.call(null, ...args);
        } finally {
            loading.value = false;
        }
    };

    return {
        loading,
        fn: callback
    };
}
